import api from './api';

export interface PaymentOrder {
  id: number;
  user_id: number;
  amount: number;
  content: string;
  status: 'pending' | 'completed' | 'failed' | 'expired';
  ribato_transaction_id?: number;
  ribato_code?: string;
  matched_at?: string;
  expires_at?: string;
  created_at: string;
  updated_at: string;
}

export interface CreateOrderRequest {
  amount: number;
  // content sẽ được tự động generate ở backend
}

export interface CreateManualOrderRequest {
  amount: number;
  content: string;
  note?: string;
}

export interface PaymentOrdersResponse {
  orders: PaymentOrder[];
  pagination: {
    page: number;
    per_page: number;
    total: number;
    pages: number;
  };
}

export const paymentService = {
  // Tạo đơn nạp tiền mới
  createOrder: async (data: CreateOrderRequest): Promise<PaymentOrder> => {
    const response = await api.post('/payments/orders', data);
    return response.data.order;
  },

  // Lấy danh sách đơn nạp tiền
  getOrders: async (params?: { status?: string; page?: number; per_page?: number }): Promise<PaymentOrdersResponse> => {
    const response = await api.get('/payments/orders', { params });
    return response.data;
  },

  // Lấy chi tiết một đơn
  getOrder: async (orderId: number): Promise<PaymentOrder> => {
    const response = await api.get(`/payments/orders/${orderId}`);
    return response.data;
  },

  // Hủy đơn nạp tiền
  cancelOrder: async (orderId: number): Promise<PaymentOrder> => {
    const response = await api.post(`/payments/orders/${orderId}/cancel`);
    return response.data.order;
  },

  // Manually check giao dịch
  checkPayments: async (): Promise<void> => {
    await api.post('/payments/check');
  },

  // Lấy tổng số tiền đã nạp thành công
  getTotalDeposited: async (): Promise<number> => {
    const response = await api.get('/payments/total-deposited');
    return response.data.total_deposited;
  },

  // Tạo đơn thanh toán thủ công
  createManualOrder: async (data: CreateManualOrderRequest): Promise<PaymentOrder> => {
    const response = await api.post('/payments/orders/manual', data);
    return response.data.order;
  },
};

